import { styled } from "@mui/system";
const Wrapper = styled("div")`
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
  align-items: center;

  & > * {
    position: relative;
    &:not(:first-child) {
      margin-left: -4px;
    }
  }
`;
const CountWrapper = styled("div")`
  && {
    margin-left: 4px;
  }
`;
export {
  CountWrapper,
  Wrapper
};
